import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import GetAppIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';

import { useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import {
  getAllBillingRoles,
  searchEmployee
} from 'src/services/employeeService';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import {
  filterProjectDelivery,
  getAllEmployeesTimeSheet,
  getProjectDelivery,
  searchProjectDelivery
} from 'src/services/timesheetService';
import { TableColumnCell } from 'src/components/TableColumnCell';
import moment from 'moment';
import {
  getProjectNature,
  getProjectStatus
} from 'src/services/projectDetailService';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const ProjectDeliveryStatus = () => {
  const navigate = useNavigate();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortIdType, setSortIdType] = useState('desc');
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });
  var initalList: any[] = [];
  const [employees, setEmployees] = useState(initalList);

  let initialProjectFilterValues = {
    client: null,
    projectStatus: null,
    nature: null,
    stakeholder: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });
  const [isDisabled, setIsDisabled] = useState(false);

  // useEffect(() => {
  //   if (employees?.length > 0 && sortIdType === 'asc') {
  //     setEmployees(employees.sort((a, b) => a.name.localeCompare(b.name)));
  //   } else if (employees?.length > 0 && sortIdType === 'desc') {
  //     setEmployees(employees.sort((a, b) => b.name.localeCompare(a.name)));
  //   }
  // }, [employees, sortIdType]);

  const filteredEmployees = applyFilters(employees, filters);

  const paginatedEmployees = applyPagination(filteredEmployees, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const getEmployeeData = () => {
    getProjectDelivery().then((res) => {
      setEmployees(res?.data || []);
    });
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [empFilter, setEmpFilter] = useState({} as any);

  const onSubmit = (data: any) => {
    filterProjectDelivery(data).then((res) => {
      setEmployees(res?.data);
    });
  };

  const resetFilterResult = () => {
    reset();
    setEmpFilter(initialProjectFilterValues);
    getEmployeeData();
  };

  //when user started to type the name in the text field
  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value);
  };

  const searchGroupsAll = async (keyword: string) => {
    const result = await searchProjectDelivery(keyword);
    setEmployees(result?.data);
  };

  useEffect(() => {
    if (searchKeywords.length > 3) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      getEmployeeData();
    }
  }, [searchKeywords]);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
          .MuiCardHeader-action{
            width: 100%
          }
        `
  );

  useEffect(() => {
    const isNullish = Object.values(empFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(empFilter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [empFilter]);

  const [projectStatus, setprojectStatus] = useState<any>([]);
  const [projectNatures, setProjectNatures] = useState<any>([]);

  useEffect(() => {
    getAllBillingRoles();
    getProjectStatus().then((res) => {
      setprojectStatus(res.data || []);
    });
    getProjectNature().then((res) => {
      setProjectNatures(res.data || []);
    });
  }, []);

  return (
    <>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Project Delivery Status
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            style={{ marginLeft: 'auto' }}
          >
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              startIcon={<GetAppIcon fontSize="small" />}
              style={{ height: '1.75rem' }}
              // onClick={handleClickOpen}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem 1rem 0rem 1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                sx={{ width: 150, mr: 2 }}
                size="small"
                placeholder="Search..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
          </Grid>
          <CardHeaderWrapper
            action={
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {toggleFilter ? (
                    <>
                      <Grid
                        container
                        sx={{ pr: 2 }}
                        spacing={2}
                        style={{
                          paddingTop: 3,
                          paddingBottom: 2,
                          justifyContent: 'space-between'
                        }}
                      >
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Client
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              {...register('client')}
                              value={empFilter.client}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  client: e.target.value
                                }));
                                setValue('client', e.target.value);
                              }}
                            >
                              {(paginatedEmployees || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.client} key={i}>
                                    {item.client}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Status
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              value={empFilter.projectStatus}
                              {...register('projectStatus')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  projectStatus: e.target.value
                                }));
                                setValue('projectStatus', e.target.value);
                              }}
                            >
                              {(projectStatus || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Natures
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.nature}
                              {...register('nature')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  nature: e.target.value
                                }));
                                setValue('nature', e.target.value);
                              }}
                            >
                              {(projectNatures || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Client Stakeholders
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.stakeholder}
                              {...register('stakeholder')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  stakeholder: e.target.value
                                }));
                                setValue('stakeholder', e.target.value);
                              }}
                            >
                              <MenuItem value={'1'}>{'1'}</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{ pr: 2 }}
                        container
                        style={{ justifyContent: 'flex-end', marginTop: 4 }}
                        xs={12}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 2 }}
                          variant="text"
                          onClick={resetFilterResult}
                          disabled={isDisabled}
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          disabled={isDisabled}
                          variant="outlined"
                          type="submit"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </form>
              </>
            }
            title=""
          />
          <TableContainer className="tableContainer hideScroll">
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell content="Client" smallFont />
                  <TableHeaderCell content="Project Name" smallFont />
                  <TableHeaderCell content="Project Status" smallFont />
                  <TableHeaderCell content="Client Stakeholder" smallFont />
                  <TableHeaderCell content="Project Nature" smallFont />
                  <TableHeaderCell content="Actual Start Date" smallFont />
                  <TableHeaderCell content="Planned Hours" smallFont />
                  <TableHeaderCell content="Actual Hours" smallFont />
                  <TableHeaderCell content="Remaining Hours" smallFont />
                  <TableHeaderCell
                    content="Actual Effort Status/Effort Utilization %"
                    smallFont
                  />
                  <TableHeaderCell content="Project Completion (%)" smallFont />
                  <TableCell
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <span
                      style={{
                        whiteSpace: 'nowrap',
                        alignItems: 'center',
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: `11px`
                      }}
                    >
                      Project Performance Effort Overrun/
                    </span>
                    <span
                      style={{
                        whiteSpace: 'nowrap',
                        alignItems: 'center',
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: `11px`
                      }}
                    >
                      Remaining Effort (%)
                    </span>
                  </TableCell>
                  {/* <TableHeaderCell
                    content=""
                    smallFont
                  /> */}
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedEmployees &&
                  paginatedEmployees?.length > 0 &&
                  paginatedEmployees.map((listItem) => {
                    return (
                      <TableRow hover>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.client}
                          </Typography>
                        </TableColumnCell>

                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.name}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.status}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.clientStakeHolder || '-'}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.projectNature || '-'}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.singleProjectDeliveryStatusDtos?.map(
                              (dt) => (
                                <Typography
                                  paddingBottom="1rem"
                                  style={{ fontSize: '11px' }}
                                  variant="body2"
                                  gutterBottom
                                  noWrap
                                >
                                  {moment(dt?.actualStartDate).format(
                                    'MM/DD/YYYY'
                                  )}
                                </Typography>
                              )
                            )}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.plannedHours}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.actualHours}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.remainingHours}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.actualEffortStatus}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.remainingEffort}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.singleProjectDeliveryStatusDtos?.map(
                            (dt) => (
                              <Typography
                                paddingBottom="1rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {dt?.remainingHours}
                              </Typography>
                            )
                          )}
                        </TableColumnCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {paginatedweeklyProjectWork?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )} */}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={filteredEmployees?.length}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default ProjectDeliveryStatus;
